import v2Axios from "../v2Axios";
import { CONFIG } from "../../config";
export const GetLessonDetailsWithSubCourseId = async (subCourseId) => {
	try {
		const response = await v2Axios.get(
			`${CONFIG.COURSEURL}/api/v2/videos/video/sub/all/` + subCourseId
		);
		return response.data;
	} catch (error) {
		// returning blank array after getting server and internet error
		return [];
	}
};
